<template>
  <div class="card">
    <div class="card__header">
      <span class="card__header__title">
        {{ title }}
      </span>
    </div>
    <div class="card__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    height: 48px;
    min-height: 48px;

    font-size: @large;
    font-weight: 600;
    border-bottom: 1px solid #DDD;

    &__title {
      display: inline-flex;
      align-items: center;
      position: relative;

      height: 100%;

      &::before {
        content: '';

        position: absolute;
        left: 0;
        bottom: 0;

        display: block;
        width: 100%;
        height: 4px;
        background: @blue;
      }
    }
  }

  &__content {
    padding: 40px 0;
    flex: 1;
  }
}
</style>
